import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=417e5d5c&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=417e5d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e5d5c",
  null
  
)

export default component.exports